<template>
    <div id="app" class="app fond">
       <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte mentions-legales">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section>
                    <h3>1/ Présentation du site</h3>
                    <h4>Propriétaire</h4>
                    <p>En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site <a>https://www.mairie-quenne.fr</a> l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi :</p>
                    <table>
                        <tbody>
                            <tr>
                                <th><i>Adresse</i></th>
                                <th><a :href="Mairie[0].acf.lien_adresse">{{Mairie[0].acf.adresse}}</a><br></th>
                            </tr>
                            <tr>
                                <th><i>Tel</i></th>
                                <th><a :href="'tel:'+Mairie[0].acf.telephone">{{Mairie[0].acf.telephone}}</a></th>
                            </tr>
                            <tr>
                                <th><i>e-mail</i></th>
                                <th><a :href="'mailto:' + Mairie[0].acf.email">{{Mairie[0].acf.email}}</a></th>
                            </tr>
                            <tr>
                                <th><i>SIRET</i></th>
                                <th><i>{{Mairie[0].acf.siret}}</i></th>
                            </tr>
                            <tr>
                                <th><i>Responsable légal</i></th>
                                <th><i v-for="elu in listeElus" :key="elu.id"><i v-if="elu.id == Mairie[0].acf.maire">{{elu.genre}} le Maire, {{elu.prenom}} {{elu.nom}}</i></i></th>
                            </tr>
                            <tr>
                                <th><i>Responsable Communication</i></th>                                
                                <th><i v-for="elu in listeElus" :key="elu.id"><i v-if="elu.id == Mairie[0].acf.responsable_communication">{{elu.genre}} {{elu.prenom}} {{elu.nom}} ({{elu.roles[0].name}})</i></i></th>
                            </tr>
                            <tr>
                                <th><i>Créateur/Administrateur</i></th>
                                <th><i>Raphaël BONIN | <a href="mailto:contact@raphaelbonin.fr">contact@raphaelbonin.fr</a></i></th>
                            </tr>
                            <tr>
                                <th><i>Dernière mise à jour technique</i></th>
                                <th><i>{{ maj_tech }}</i></th>
                            </tr>
                            <tr>
                                <th><i>Hébergeur</i></th>
                                <th><i>OVH - 2 rue Kellerman 59100 Roubaix</i></th>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <hr>
                <section>
                    <h3>2/ Conditions génarales d'utilisation du site et des services proposés</h3>
                    <p>L'utilisation du site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a> implique l'acceptation pleine et entière des conditions générales d'utilisation ci-après décrites. Ces conditions d’utilisation sont susceptibles d’être modifiées ou complétées à tout moment, les utilisateurs du site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a> sont donc invités à les consulter de manière régulière.</p>
                    <p>Ce site est normalement accessible à tout moment aux utilisateurs. Une interruption pour raison de maintenance technique peut être toutefois décidée par l'adminsitrateur, qui s’efforcera alors de communiquer préalablement aux utilisateurs les dates et heures de l’intervention.</p>
                    <p>Le site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a> est mis à jour régulièrement par <i v-for="elu in listeElus" :key="elu.id"><i v-if="elu.id == Mairie[0].acf.responsable_communication">{{elu.genre}} {{elu.prenom}} {{elu.nom}} ({{elu.roles[0].name}})</i></i>. De la même façon, les mentions légales peuvent être modifiées à tout moment : elles s’imposent néanmoins à l’utilisateur qui est invité à s’y référer le plus souvent possible afin d’en prendre connaissance.</p>
                </section>
                <hr>
                <section>
                    <h3>3/ Description des services founis</h3>
                    <p> Le site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a> a pour objet de fournir une information concernant l’ensemble des activités de la société.</p>
                    <p>Mairie de Quenne s’efforce de fournir sur le site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a> des informations aussi précises que possible. Toutefois, il ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu’elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.</p>
                    <p>Tous les informations indiquées sur le site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a> sont données à titre indicatif, et sont susceptibles d’évoluer. Par ailleurs, les renseignements figurant sur le site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a> ne sont pas exhaustifs. Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne.</p>
                </section>
                <hr>
                <section>
                    <h3>4/ Limitations contratuelles sur les données techniques</h3>
                    <p>Le site utilise la technologie JavaScript.</p>
                    <p>Le site Internet ne pourra être tenu responsable de dommages matériels liés à l’utilisation du site. De plus, l’utilisateur du site s’engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour</p>
                </section>
                <hr>
                <section>
                    <h3>5/ Propriété intellectuelle et contrefaçon</h3>
                    <p>La Mairie de Quenne est propriétaire des droits de propriété intellectuelle ou détient les droits d’usage sur tous les éléments accessibles sur le site, notamment les textes, images, graphismes, logo, icônes, sons, logiciels.</p>
                    <p>Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de : Mairie de Quenne.</p>
                    <p>Toute exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient sera considérée comme constitutive d’une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.</p>
                </section>
                <hr>
                <section>
                    <h3>6/ Limitations de responsabilité</h3>
                    <p>La Mairie de Quenne ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a>, et résultant soit de l’utilisation d’un matériel ne répondant pas aux spécifications indiquées au point <b>4/ Limitations contractuelles de données techniques</b>, soit de l’apparition d’un bug ou d’une incompatibilité.</p>
                    <p>La Mairie de Quenne ne pourra également être tenue responsable des dommages indirects (tels par exemple qu’une perte de marché ou perte d’une chance) consécutifs à l’utilisation du site <a href="https://mairie-quenne.fr">mairie-quenne.fr</a>.</p>
                </section>
                <hr>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Mention-Legale',
    data () {
        return{
            mention:{
                id:0,
                acf:{
                    date:null,
                }
            },
            Mairie:{
                id:0,
                acf:{
                    telephone: 0,
                    email: null,
                    adresse: null,
                    complement_adresse: null,
                    lien_adresse: null,
                    horaires:{},
                    image: {
                        id:0,
                        url:null
                    },
                    visuels: {},
                    logo:{}, 
                    maire: {
                        id:0
                    },
                    siret:0,
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            listeElus:{
                id:0,
                acf:{
                    prenom:null,
                    nom:null,
                    roles:{},
                    description:null,
                    image:{}
                }
            },
            maj_tech: "",
        }
    }, 

    created(){  
        this.maj_tech = param.maj_tech
        axios.get(param.hostacf+'mentions')
        .then(response =>{
        this.mention = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.hostacf+'Mairie')
        .then(response =>{
        this.Mairie = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'elu/v1/listeElus')
        .then(response =>{
        this.listeElus = response.data;
        console.log(this.listeElus)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Mentions légales'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    }
}
</script>

<style scoped>
h3{
    text-align: left;
}
b{
    font-weight: 700;
}
</style>




// WEBPACK FOOTER //
// src/components/Mentions-Legales.vue